import { ChevronDownIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box, Button,
    Checkbox,
    Collapse, Flex, Icon, Input,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Select,
    Text,
    Tooltip,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import CustomDeepLinkInput from 'components/genericForms/CustomDeepLinkInput';
import { useFormik } from 'formik';
import { useState } from 'react';
import { FiChevronUp } from 'react-icons/fi';
import { MdClose, MdEdit } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useUpdateAdspressoAdCreativeByIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import {
    call_to_action_options
} from 'utils/callToActions';
import { removeEmptyValues } from 'utils/functions';
import { object, string } from "yup";
import BuildUrlParamsUpdate from '../BuildUrlParamsUpdate';
import UrlParametersUpdate from '../UrlParametersUpdate';
import CatalogueFrameForSingle from 'components/genericForms/CatalogueFrameForSingle';
import CatalogueAdPreview from '../CatalogueAdPreview';
import { FaEye } from 'react-icons/fa';

const mustStartWithHttpRegex = /^https?:\/\/.+$/;

let schema = object().shape({
    type: string()
        .required('Type is required'),
    link: string()
        .url('Must be a valid website URL')
        .required('Url is required'),
    template_url_spec: object().shape({
        android: object().shape({
            url: string()
            .matches(mustStartWithHttpRegex, 'Must be a valid URL starting with http:// or https://')
        }),
        ios: object().shape({
            url: string()
            .matches(mustStartWithHttpRegex, 'Must be a valid URL starting with http:// or https://')
        }),
        web: object().shape({
            url: string()
            .matches(mustStartWithHttpRegex, 'Must be a valid URL starting with http:// or https://')
        }),

    })
})

function CatalogueSingleMediaUpdateForm({ applinkTreatment, creative, creatives, adData, adAccount, onDelete }) {

    const inputBackground = useColorModeValue('#F5F3F9', '#1e1530');
    const toast = useToast();
    const [isCollapsed, setisCollapsed] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const { isOpen: isAdPreviewModalOpen, onOpen: onAdPreviewModalOpen, onClose: onAdPreviewModalClose } = useDisclosure();
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const { isOpen: isCreativeModalOpen, onOpen: onCreativeModalOpen, onClose: onCreativeModalClose } = useDisclosure();

    const [updateAdspressocreativeAds, { isLoading: isAdspressoAdsetUpdating }] = useUpdateAdspressoAdCreativeByIdMutation({});
    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adAccount?.adsAccountId}, {skip: !adAccount?.adsAccountId});

    const { description, image_hash, link, message, name, thumbnail, url, video_id, _id, type, url_tags, fileName, contextual_multi_ads, product_set_id, caption, degrees_of_freedom_spec, template_url_spec, image_layer_specs } = creative || {}

    const singleMediaFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            applink_treatment: applinkTreatment ? applinkTreatment : 'web_only',
            name: name || '',
            message: message || '',
            description: description || '',
            type: type,
            link: link || '',
            caption: caption || '',
            url: url || '',
            url_tags: url_tags || '',
            fileName: fileName || '',
            template_url_spec: {
                web: {
                  url: template_url_spec?.web?.url || '',
                },
                config: {
                  app_id: template_url_spec?.config?.app_id || ''
                },
                android: {
                  url: template_url_spec?.android?.url || '',
                },
                ios: {
                  url: template_url_spec?.ios?.url || '',
                },
            },
            override_catalog: template_url_spec?.web?.url ? true : false || false,
            product_set_id: product_set_id,
            enroll_status: contextual_multi_ads?.enroll_status ? contextual_multi_ads?.enroll_status : 'OPT_OUT',
            pac_relaxation_enroll_status: degrees_of_freedom_spec?.creative_features_spec?.pac_relaxation?.enroll_status || 'OPT_IN',  
            image_layer_specs: image_layer_specs || [],        
        },
        validationSchema: schema,
        onSubmit: (values, { resetForm }) => {

            const { name, description,applink_treatment, message, url, type, link, url_tags, fileName, enroll_status, template_url_spec, product_set_id, image_layer_specs } = values;

            let videoId = video_id ? { video_id } : null;
            let imageHash = image_hash ? { image_hash } : null;
            let thumbnail_ = thumbnail ? { thumbnail } : null;

            const templateUrlSpec =
                applink_treatment === 'web_only'
                    ? {
                        web: {
                            url: template_url_spec?.web?.url || '',
                        },
                    }
                    : {
                        web: {
                            url: template_url_spec?.web?.url || '',
                        },
                        ios: {
                            url: template_url_spec?.ios?.url || '',
                        },
                        android: {
                            url: template_url_spec?.android?.url || '',
                        },
                        config: {
                            app_id: template_url_spec?.config?.app_id || '',
                        },
                    };
            
            const filtered_image_layer_specs = image_layer_specs?.map(layer => {
                // Create a shallow copy of the object without frame_name and frame_url
                const { frame_name, frame_url, ...rest } = layer;
                return rest;
            }) || [];
                    
            const payload = {
                name,
                fileName,
                contextual_multi_ads: {
                    enroll_status,
                },
                // applink_treatment,
                product_set_id,
                description,
                ...(message?.trim() && { message }),
                url,
                link: link,
                type: type,
                template_url_spec: templateUrlSpec,
                ...(filtered_image_layer_specs.length > 0 && {
                    image_layer_specs: filtered_image_layer_specs,
                }),
                ...(url_tags?.trim() && { url_tags }),
                ...thumbnail_,
                ...videoId,
                ...imageHash
            };

            // console.log({ payload });
            const filteredPayload = removeEmptyValues(payload);

            try {
                updateAdspressocreativeAds({ adcreativeId: _id, payload: filteredPayload }).unwrap()
                    .then(response => {
                        toast({
                            position: "top-right",
                            title: "Ad creative updated",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                        });
                    })
                    .catch(error => {
                        const errorMessage = error?.data?.message || "An unexpected error occurred";
                        const formattedMessage = errorMessage.replace(/['"]/g, '');

                        toast({
                            position: "top-right",
                            title: "Error updating Ad creative",
                            description: formattedMessage,
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                        });
                    });
            } catch (error) {
                console.log(error);

            } finally {
                setisCollapsed(false);
                resetForm();
            }
        }
    });

    const handleUrlChange = (constructedUrl) => {
        singleMediaFormik.setFieldValue('link', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        singleMediaFormik.setFieldValue('url_tags', constructedUrl);
    };

    return (
        <>
            {/* Modal for "Add a frame" */}
            {isCreativeModalOpen && 
                <CatalogueFrameForSingle 
                    isOpen={isCreativeModalOpen}
                    onClose={onCreativeModalClose}
                    productSetId={product_set_id}
                    selectedAdAccounts={[{
                        adsAccountId: adAccount?.adsAccountId,
                        adsAccountName: adAccount?.adsAccountName,
                    }]}
                    values={singleMediaFormik.values}
                    onChangeImageLayerSpecs={(framesData) => {
                        singleMediaFormik.setFieldValue(
                            "image_layer_specs",
                            framesData
                    )}}
                />
            }

            <Modal
                isOpen={isAdPreviewModalOpen}
                onClose={onAdPreviewModalClose}
                size="3xl"
                scrollBehavior={"inside"}
            >
                <ModalOverlay />
                <ModalContent minH={'60vh'}>
                    <ModalHeader>Ad preview</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {creative && adData ? (() => {
                            const isCatalogue = creative?.product_set_id && creatives?.force_single_link === 'true';

                            if (isCatalogue) {
                                return (
                                    <CatalogueAdPreview
                                        file={creative}
                                        adData={adData}
                                        creatives={creatives}
                                    />
                                );
                            }

                            return <Text>No preview available</Text>;
                        })() : null}
                    </ModalBody>
                    <ModalFooter justifyContent={'flex-start'} css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }} py={2}>
                        <Text fontSize={'14px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={singleMediaFormik?.values} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={singleMediaFormik?.values} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Box key={url} p={2} borderWidth={1} borderRadius="md" borderColor="gray.200">
                <Flex alignItems="center" gap={2} justify="space-between" mb={2}>
                    <Flex alignItems="center" gap={2}>
                        <Flex direction={'column'}>
                            <Text fontSize="10px" noOfLines={1}>
                                {name}
                            </Text>

                            {/* <Flex gap={1}>
                                {singleMediaFormik.values.description ? (
                                    <Text fontSize="10px" noOfLines={1}>{truncateName(singleMediaFormik.values?.description)}</Text>
                                ) : (
                                    <Text fontSize="10px">Enter a description</Text>
                                )}
                            </Flex> */}
                        </Flex>

                    </Flex>
                    <Flex alignItems="center" gap={'5px'}>
                        <Tooltip label="Edit copy" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.500' }}
                                    as={isCollapsed ? FiChevronUp : MdEdit}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    onClick={() => userInfo?.role === 'client' && setisCollapsed(!isCollapsed)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'inherit'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip label="Ad preview" fontSize="xs">
                            <Box>
                                 <Icon
                                    _hover={{ color: 'gray.500' }}
                                    as={FaEye}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    onClick={onAdPreviewModalOpen}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'inherit'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip label="Remove creative" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.400' }}
                                    as={MdClose}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    boxSize={5}
                                    onClick={() => userInfo?.role === 'client' && onDelete(_id)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'red.500'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                    </Flex>
                </Flex>
                <Collapse in={isCollapsed}>
                    <Box>
                        <Flex direction={'column'}>

                            {/* Multi-advertiser ads Section */}
                            <Flex direction="column" mb={4} borderRadius="md" gap={2}>
                                <Checkbox
                                    onChange={(e) => {
                                        singleMediaFormik.setFieldValue("enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                    }}
                                    colorScheme="brand"
                                    isChecked={singleMediaFormik.values.enroll_status === 'OPT_IN'}
                                >
                                    <Flex align={'center'}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                </Checkbox>
                            </Flex>

                            <Flex direction={'column'} gap={2}>

                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center">
                                        <Text fontWeight="bold">Destination</Text>
                                    </Flex>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Default destination</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>
                                                        Send people to either your app or website URL.
                                                    </Text>
                                                </Box>
                                            }
                                            fontSize="md">
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Select
                                        name="applink_treatment"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={singleMediaFormik.handleChange}
                                        onBlur={singleMediaFormik.handleBlur}
                                        value={singleMediaFormik.values.applink_treatment}
                                        isDisabled
                                    >
                                        <option value="web_only">Website</option>
                                        <option value="deeplink_with_web_fallback">App</option>
                                    </Select>
                                </Flex>
                                
                                {/* {Boolean(adData?.useFileName) ? (
                                    <Flex mb={4} direction="column" gap={2}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontSize={'14px'} fontWeight="bold">Ad name</Text>
                                        </Flex>
                                        <Input
                                            placeholder="Ad name"
                                            name="fileName"
                                            size={'sm'}
                                            borderRadius="md"
                                            value={singleMediaFormik.values.fileName}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                    </Flex>
                                ) : null} */}

                                {singleMediaFormik.values.applink_treatment === 'deeplink_with_web_fallback' ?
                                <>
                                    <Flex direction={'column'} gap={1} mt={'10px'}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Mobile app</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Select
                                            name={`template_url_spec.config.app_id`}
                                            bg="#fff"
                                            size="sm"
                                            borderRadius="md"
                                            onChange={singleMediaFormik.handleChange}
                                            onBlur={singleMediaFormik.handleBlur}
                                            value={singleMediaFormik?.values?.template_url_spec?.config?.app_id}
                                        >
                                            <option value="">Choose app</option>
                                            {advertisableApps?.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </Flex>

                                    <Flex direction={'column'} gap={2} mt={'10px'}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontWeight="bold" fontSize="14px">iOS deep link</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="14px" p="5px">
                                                        <Text>
                                                            Use a deep link to specify where in your app to send people. Entering an iOS deep link here will override any iOS deep links for items in the selected catalog.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <CustomDeepLinkInput
                                            value={singleMediaFormik.values?.template_url_spec?.ios?.url}
                                            onChange={(url) => {
                                                singleMediaFormik.setFieldValue('template_url_spec.ios.url', url)
                                            }}
                                            error={
                                                singleMediaFormik.errors?.template_url_spec?.ios?.url
                                            }
                                            placeholder={'Enter the deep link URL'}
                                            maxW={'350px'}
                                        />
                                    </Flex>

                                    <Flex direction={'column'} gap={2} mt={'10px'}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontWeight="bold" fontSize="14px">Android deep link</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="14px" p="5px">
                                                        <Text>
                                                            Use a deep link to specify where in your app to send people. Entering an Android deep link here will override any Android deep links for items in the selected catalog.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <CustomDeepLinkInput
                                            value={singleMediaFormik.values?.template_url_spec?.android?.url}
                                            onChange={(url) => singleMediaFormik.setFieldValue('template_url_spec.android.url', url)}
                                            error={
                                                singleMediaFormik.errors?.template_url_spec?.android?.url
                                            }
                                            placeholder={'Enter the deep link URL'}
                                            maxW={'350px'}
                                        />
                                    </Flex>
                                </>
                                : null}

                            <Flex direction="column" gap={1} mt={'10px'}>
                                <Flex alignItems="center">
                                    <Text fontWeight="bold" fontSize={'14px'}>Website URL</Text>
                                    <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>Enter the URL for the webpage you want people to visit</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="link"
                                    placeholder="Enter a URL"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={singleMediaFormik.values.link}
                                    onChange={singleMediaFormik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} textDecoration={'underline'}>{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {singleMediaFormik.touched.link && singleMediaFormik.errors.link && (
                                    <Text fontSize={"12px"} color="red.500">{singleMediaFormik.errors.link}</Text>
                                )}
                            </Flex>

                            <Flex direction="column" gap={2} mt={'10px'}>
                                <Checkbox
                                    onChange={(e) => {
                                        singleMediaFormik.setFieldValue("override_catalog", e.target.checked);
                                    }}
                                    colorScheme="brand"
                                    isChecked={singleMediaFormik.values.override_catalog}
                                    alignItems="flex-start"
                                >
                                    <Flex direction="column">
                                        <Flex align="center" mt={'-3px'}>
                                            <Text fontWeight="bold" fontSize="14px">
                                                Override catalog website deep links&nbsp;
                                            </Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>
                                                            Link each item in your catalog to a specific page on your website.
                                                            You can add deep links in your catalog's data feed. Use a deep link
                                                            to specify where in your website to send people. Entering a deep link
                                                            to website here will override any website deep links for items in the
                                                            selected catalog.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        {/* Description text on the next line */}
                                        <Text fontSize="11px">
                                            This allows you to override any website deep links for items in the selected catalog.
                                        </Text>
                                    </Flex>
                                </Checkbox>
                                {singleMediaFormik.values.override_catalog ?
                                    <Flex direction={'column'} gap={2}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontWeight="bold" fontSize="14px">Set catalog deep links</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="14px" p="5px">
                                                        <Text>
                                                            Enter the URL for the website deep link you want people to visit. This URL will override the destination links in your catalog.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>


                                        <CustomDeepLinkInput
                                            value={singleMediaFormik.values?.template_url_spec?.web?.url}
                                            onChange={(url) => singleMediaFormik.setFieldValue('template_url_spec.web.url', url)}
                                            error={
                                                singleMediaFormik.touched?.template_url_spec?.web?.url &&
                                                singleMediaFormik.errors?.template_url_spec?.web?.url
                                            }
                                            placeholder={'http://www.example.com/page'}
                                            maxW='350px'
                                        />

                                    </Flex>
                                : null}
                            </Flex>

                            <Flex align="center" wrap="wrap" gap={2}>
                                <Text fontWeight="bold" fontSize={'14px'}>Creative tools</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                    <Box fontSize="12px" p="5px">
                                        <Text>
                                        Customise how images from your catalogue appear in your ads. Frame products and services with engaging graphics and add helpful info from your catalogue, such as price or free delivery.
                                        </Text>
                                    </Box>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                                
                            <Flex>
                                <Menu>
                                <MenuButton
                                    as={Button}
                                    variant="outline"
                                    fontWeight="normal"
                                    bg={inputBackground}
                                    _active={{ background: inputBackground, borderColor: "blue.500" }}
                                    _hover={{ background: inputBackground, borderColor: "gray.300" }}
                                    rightIcon={<ChevronDownIcon boxSize={5} />}
                                    size="sm"
                                >
                                Edit creative
                                </MenuButton>
                                <MenuList minW="135px" px={2} py={1}>
                                <MenuItem
                                    fontSize="14px"
                                    onClick={onCreativeModalOpen}
                                >
                                    Add a frame
                                </MenuItem>
                                </MenuList>
                                </Menu>
                            </Flex>

                            <Flex direction="column" gap={2}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontSize={'14px'} fontWeight="bold">Primary text</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>
                                                    The primary text for your ad appears in most placements, though the position
                                                    varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                                                    characters or less.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md">
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <CustomDeepLinkInput
                                    value={singleMediaFormik.values.message}
                                    onChange={(message) => singleMediaFormik.setFieldValue('message', message)}
                                    error={
                                        singleMediaFormik?.touched?.message &&
                                        singleMediaFormik?.errors?.message
                                    }
                                    placeholder={'Tell people what your ad is about'}
                                    maxW='350px'
                                />
                            </Flex>

                            <Flex direction="column" gap={2}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontSize={'14px'} fontWeight="bold">Headline</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>
                                                    Add up to five brief headlines to let people know what your ad is about. Each
                                                    headline can have a maximum of 255 characters. Headlines won't appear in all
                                                    placements.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md">
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <CustomDeepLinkInput
                                    value={singleMediaFormik.values.name}
                                    onChange={(name) => singleMediaFormik.setFieldValue('name', name)}
                                    error={
                                        singleMediaFormik?.touched?.name &&
                                        singleMediaFormik?.errors?.name
                                    }
                                    placeholder={'Write a short headline'}
                                    maxW='350px'
                                />
                            </Flex>

                            {/* <Box direction="column">
                                <Flex alignItems="center" mb={'8px'} gap={2}>
                                    <Text fontSize={'14px'} fontWeight="bold">Description</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>
                                                    Add up to five link descriptions to emphasize why people should visit your
                                                    website. This won't appear in all placements.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Textarea
                                    placeholder="Include additional details"
                                    name="description"
                                    size={'sm'}
                                    borderRadius="md"
                                    value={singleMediaFormik.values.description}
                                    onChange={singleMediaFormik.handleChange}
                                    rows={2}
                                />
                            </Box> */}
                            
                            <Box direction="column">
                                <Flex alignItems="center" mb={'8px'} gap={2}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Call to action</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>Show a button or link on your ad that represents the action you want people to take.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Select
                                    name="type"
                                    borderRadius={'md'}
                                    value={singleMediaFormik.values.type}
                                    onChange={singleMediaFormik.handleChange}
                                    size={'sm'}
                                >
                                    {call_to_action_options?.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </Box>

                            <Flex direction="column" gap={1}>
                                <Flex alignItems={'center'}>
                                    <Text mb={'5px'} fontWeight="bold" fontSize={'14px'}>
                                        URL parameters{" "}
                                        {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                    </Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p={'5px'}>
                                                <Text >
                                                    Add parameters to the end of your website URL to track where your visitors are coming from.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="url_tags"
                                    placeholder="key1=value1&key2=value2"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={singleMediaFormik.values.url_tags}
                                    onChange={singleMediaFormik.handleChange}
                                />
                                <Flex mt={1}>
                                    <Button onClick={() => {
                                        setUrlParamModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                            </Flex>

                            <Flex justifyContent="flex-start" mt={'20px'}>
                                <Button
                                    colorScheme="brand"
                                    onClick={() => singleMediaFormik.handleSubmit()}
                                    size={'sm'}
                                    isLoading={isAdspressoAdsetUpdating}
                                >
                                    Save
                                </Button>
                            </Flex>
                            </Flex>
                        </Flex>
                    </Box>
                </Collapse>
            </Box>
        </>
    )
}

export default CatalogueSingleMediaUpdateForm